document.addEventListener('DOMContentLoaded', () => {
    const sliderContainer = document.querySelector('.slider-section');

    // Track manually closed accordions - they should stay closed only temporarily
    const manuallyClosed = new Set();
    // Track which slides we've visited to know when we're revisiting
    const visitedSlides = new Set();

    const sliderContainerSwiper = new Swiper(sliderContainer.querySelector('.swiper'), {
        loop: false,
        speed: 500,
        centeredSlides: false,
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        spaceBetween: 6,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
        freeMode: true,
        mousewheel: {
            forceToAxis: true,
            sensitivity: 1,
            releaseOnEdges: true,
        },
        breakpoints: {
            500: {
                slidesPerView: 1.75,
                spaceBetween: 8,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
            },
            768: {
                slidesPerView: 2.65,
                spaceBetween: 8,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
            },
            1440: {
                slidesPerView: 'auto',
                spaceBetween: 8,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                // centeredSlides: true,
                initialSlide: 0,
            },
        },
        pagination: {
            el: sliderContainer.querySelector('.swiper-pagination'),
            type: 'progressbar', // Use progress bar type instead of dots
        },
        on: {
            slideChange: function () {
                // Only close accordions that weren't manually closed
                document.querySelectorAll('.slider-section__accordion-list-item-header.active').forEach((activeHeader) => {
                    if (!manuallyClosed.has(activeHeader)) {
                        closeAccordion(activeHeader, activeHeader.nextElementSibling);
                    }
                });

                // Clear manually closed status for slides we're moving away from
                // This ensures when you come back to a slide, it will open normally
                manuallyClosed.clear();
            },
            transitionEnd: function () {
                // After transition ends, check if any slides are 100% visible
                checkForFullyVisibleSlides(this);
            },
            // Also check when scrolling/dragging ends
            momentumEnd: function () {
                checkForFullyVisibleSlides(this);
            },
            // For free mode, also check when scrolling stops
            scrollEnd: function () {
                checkForFullyVisibleSlides(this);
            },
            // For resize events
            resize: function () {
                checkForFullyVisibleSlides(this);
            },
            // Initial setup once loaded
            init: function () {
                checkForFullyVisibleSlides(this);
            },
        },
    });

    function checkForFullyVisibleSlides(swiper) {
        // Delay slightly to ensure accurate calculations
        setTimeout(() => {
            const containerRect = swiper.el.getBoundingClientRect();
            const containerLeft = containerRect.left;
            const containerRight = containerRect.right;

            // Check each slide
            swiper.slides.forEach((slide, index) => {
                const slideRect = slide.getBoundingClientRect();

                // Check if slide is completely within the container view
                const isFullyVisible = slideRect.left >= containerLeft && slideRect.right <= containerRight && Math.abs(slideRect.width - slide.offsetWidth) < 2; // Allow 1-2px difference for rounding errors

                // If fully visible, check if we should open its accordion
                if (isFullyVisible) {
                    const slideId = slide.dataset.slideId || `slide-${index}`;
                    if (!slide.dataset.slideId) {
                        slide.dataset.slideId = slideId;
                    }

                    const header = slide.querySelector('.slider-section__accordion-list-item-header');
                    const content = header?.nextElementSibling;

                    // Only auto-open if not manually interacted with during this viewing
                    if (header && content && !header.classList.contains('active') && !manuallyClosed.has(header)) {
                        // Close any previously opened accordions that weren't manually toggled
                        document.querySelectorAll('.slider-section__accordion-list-item-header.active').forEach((activeHeader) => {
                            if (activeHeader !== header && !manuallyClosed.has(activeHeader)) {
                                closeAccordion(activeHeader, activeHeader.nextElementSibling);
                            }
                        });

                        // Open this accordion
                        openAccordion(header, content);
                    }
                }
            });
        }, 50);
    }

    function updateProgressBar(swiper) {
        const totalSlides = swiper.slides.length - swiper.loopedSlides * 2; // Adjust for looped slides if loop is enabled
        const currentSlide = swiper.realIndex + 1; // Get the current slide index (1-based)
        const progress = (currentSlide / totalSlides) * 100; // Calculate progress as percentage
        const progressBar = swiper.pagination.progressbar;

        if (progressBar) {
            progressBar.style.width = `${progress}%`; // Set the progress bar fill width
        }
    }

    // Handle accordion interactions
    const headers = document.querySelectorAll('.slider-section__accordion-list-item-header');
    const icons = document.querySelectorAll('.slider-section__accordion-list-item-header-icon');

    headers.forEach((header) => {
        header.addEventListener('click', function (event) {
            const content = header.nextElementSibling;
            const isOpen = header.classList.contains('active');

            // Close any other open accordion items
            document.querySelectorAll('.slider-section__accordion-list-item-header.active').forEach((activeHeader) => {
                if (activeHeader !== header) {
                    activeHeader.removeAttribute('data-manually-toggled');
                    manuallyClosed.delete(activeHeader);
                    closeAccordion(activeHeader, activeHeader.nextElementSibling);
                }
            });

            // Toggle the clicked item
            if (isOpen) {
                closeAccordion(header, content);
                // Add this header to the manually closed set only for this viewing session
                manuallyClosed.add(header);
            } else {
                openAccordion(header, content);
                // Remove from manually closed if it was there
                manuallyClosed.delete(header);
            }

            // Prevent click from propagating to swiper
            event.stopPropagation();
        });
    });

    // Add specific handler for icon clicks to ensure they work properly
    icons.forEach((icon) => {
        icon.addEventListener('click', function (event) {
            // Find the parent header
            const header = this.closest('.slider-section__accordion-list-item-header');
            if (header) {
                const content = header.nextElementSibling;
                const isOpen = header.classList.contains('active');

                // Toggle accordion state
                if (isOpen) {
                    closeAccordion(header, content);
                    // Add this header to the manually closed set only for this viewing session
                    manuallyClosed.add(header);
                } else {
                    // Close any other open accordion items
                    document.querySelectorAll('.slider-section__accordion-list-item-header.active').forEach((activeHeader) => {
                        if (activeHeader !== header) {
                            activeHeader.removeAttribute('data-manually-toggled');
                            manuallyClosed.delete(activeHeader);
                            closeAccordion(activeHeader, activeHeader.nextElementSibling);
                        }
                    });

                    // Open this one
                    openAccordion(header, content);
                    // Remove from manually closed if it was there
                    manuallyClosed.delete(header);
                }
            }

            // Prevent event bubbling to swiper
            event.stopPropagation();
        });
    });

    function openAccordion(header, content) {
        header.classList.add('active');
        // Set the height to the scrollHeight to animate opening
        content.style.height = content.scrollHeight + 'px';

        // When the transition ends, remove the inline height if open so it can adapt if content changes.
        content.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'height' && header.classList.contains('active')) {
                content.style.height = 'auto';
            }
            content.removeEventListener('transitionend', handler);
        });
    }

    function closeAccordion(header, content) {
        header.classList.remove('active');

        // For a smooth close, if the height is 'auto' we first set it to the current pixel height.
        if (content.style.height === 'auto') {
            content.style.height = content.scrollHeight + 'px';
            // Force reflow to apply the new fixed height
            content.offsetHeight;
        }
        // Then animate to 0
        content.style.height = '0px';
    }

    // For mobile scroll/touch events
    sliderContainer.querySelector('.swiper').addEventListener('touchend', () => {
        setTimeout(() => {
            checkForFullyVisibleSlides(sliderContainerSwiper);
        }, 50);
    });

    // For desktop scroll events
    sliderContainer.querySelector('.swiper').addEventListener(
        'wheel',
        () => {
            setTimeout(() => {
                checkForFullyVisibleSlides(sliderContainerSwiper);
            }, 200);
        },
        { passive: true },
    );
});
